import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import loginImage from '../assets/images/login.png';
import AuthForm from '../components/AuthForm';
import { getErrorMessage, loginUser, registerUser } from '../services/authApi';

function AuthPage({ onAuthenticated, isAuthenticated }) {
  console.log(process.env.REACT_APP_API_URL)
  const navigate = useNavigate();
  const [mode, setMode] = useState('login');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  const handleModeChange = (nextMode) => {
    setMode(nextMode);
    setError('');
  };

  const handleFieldChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const nextUser =
        mode === 'login'
          ? await loginUser({
              email: formData.email,
              password: formData.password
            })
          : await registerUser({
              name: formData.name,
              email: formData.email,
              password: formData.password,
              confirmPassword: formData.confirmPassword
            });

      onAuthenticated(nextUser);
      navigate('/home', { replace: true });
    } catch (requestError) {
      setError(
        getErrorMessage(
          requestError,
          mode === 'login' ? 'Login failed. Please try again.' : 'Registration failed. Please try again.'
        )
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-maroon-100 via-maroon-50 to-maroon-200 p-4 md:p-6">
      <div className="grid w-full max-w-5xl overflow-hidden rounded-2xl bg-white shadow-2xl shadow-maroon-950/15 md:grid-cols-2">
        <div className="hidden items-center justify-center bg-gradient-to-br from-maroon-900 via-maroon-800 to-maroon-700 p-8 md:flex">
          <img src={loginImage} alt="Login visual" className="h-auto w-full max-w-sm object-contain" />
        </div>
        <AuthForm
          mode={mode}
          loading={loading}
          error={error}
          formData={formData}
          onModeChange={handleModeChange}
          onFieldChange={handleFieldChange}
          onSubmit={handleSubmit}
        />
      </div>
    </div>
  );
}

export default AuthPage;
